module.exports = __webpack_public_path__ + "static/media/(DH)-Artesanato-24.64a36122.jpg";